import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
    deleteAssignmentRuleMutation,
    editAssignmentRuleMutation,
    newAssignmentRulesMutation,
    toggleAssignmentRuleActivationMutation
} from '../../../graph-ql/mutations';
import { getAssignmentRules } from '../../../graph-ql/queries';
import { GetAssignmentRulesResponse } from '../../models/common/assigmentRules/assignmentRulesResponse';
import { DeleteAssignmentRuleInput } from '../../models/common/assigmentRules/deleteAssignmentRules.input';
import { EditAssignmentRuleInput } from '../../models/common/assigmentRules/editAssignmentRules.input';
import { NewAssignmentRulesInput } from '../../models/common/assigmentRules/newAssignmentRulesInput';
import { GetAssignmentRulesInput } from './../../../shared/models/common/assigmentRules/getAssignmentRulesInput';

@Injectable()
export class AssignmentRulesService {

    constructor(public apollo: Apollo) { }

    getAssignmentRules(getAssignmentRulesInput: GetAssignmentRulesInput): Observable<GetAssignmentRulesResponse> {
        return this.apollo.query<GetAssignmentRulesResponse>({
            query: getAssignmentRules,
            variables: {
                input: getAssignmentRulesInput
            }
        }).pipe(map(result => {
            if (!result.data['getAssignmentRules']) {
                return new GetAssignmentRulesResponse([], 0);
            }
            return new GetAssignmentRulesResponse(
                result.data['getAssignmentRules']['assignmentRules'],
                result.data['getAssignmentRules']['assignmentRulesCount']
            );
        }));
    }

    editAssignmentRule$(editAssignmentRuleInput: EditAssignmentRuleInput): Observable<any> {
        return this.apollo
            .mutate<any>({
                mutation: editAssignmentRuleMutation,
                variables: {
                    input: editAssignmentRuleInput
                }
            })
            .pipe(map(result => {
                if (result.errors && result.errors.length > 0) {
                    throw new Error('AssignmentRule not edit');
                }

                return result;
            }));
    }

    toogleAssignmentRuleActivation$(editAssignmentRuleInput: EditAssignmentRuleInput): Observable<any> {
        return this.apollo
            .mutate<any>({
                mutation: toggleAssignmentRuleActivationMutation,
                variables: {
                    input: editAssignmentRuleInput
                }
            })
            .pipe(map(result => {
                if (result.errors && result.errors.length > 0) {
                    throw new Error('AssignmentRule actived not toogled');
                }

                return result;
            }));
    }

    deleteAssignmentRule$(deleteAssignmentRuleInput: DeleteAssignmentRuleInput): Observable<any> {
        return this.apollo
            .mutate<any>({
                mutation: deleteAssignmentRuleMutation,
                variables: {
                    input: deleteAssignmentRuleInput
                }
            })
            .pipe(map(result => {
                if (result.errors && result.errors.length > 0) {
                    throw new Error('AssignmentRule not delete');
                }

                return result;
            }));
    }

    newAssignmentRules$(newAssignmentRulesInput: NewAssignmentRulesInput): Observable<any> {
        return this.apollo
            .mutate<any>({
                mutation: newAssignmentRulesMutation,
                variables: {
                    input: {
                        assignmentRules: newAssignmentRulesInput.assignmentRules
                    }
                }
            })
            .pipe(map(result => {
                if (result.errors && result.errors.length > 0) {
                    throw new Error('Assignment rules has not been created');
                }

                return result;
            }));

    }
}
